<template>
  <div data-arrows-hero :class="[bottom ? $style.bottom : $style.container]">
    <div :class="$style.next">
      <ArrowButton :labeled="bottom" :id="nextPage.id" :direction="'right'" :action="clickRight">
        {{ nextPage.title }}
      </ArrowButton>
    </div>
    <div :class="$style.prev">
      <ArrowButton :labeled="bottom" :id="prevPage.id" :direction="'left'" :action="clickLeft">
        {{ prevPage.title }}
      </ArrowButton>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/scripts/event-bus'

import ArrowButton from '@/components/ArrowButton'

export default {
  props: ['bottom'],

  data() {
    return {
      hm: null
    }
  },

  components: {
    ArrowButton
  },

  computed: {
    ...mapGetters({
      nextPage: 'getNextPage',
      prevPage: 'getPrevPage',
      currentHand: 'currentHand'
    })
  },

  mounted() {
    if (!this.bottom) {
      EventBus.$on('swipedLeft', this.clickRight)
      EventBus.$on('swipedRight', this.clickLeft)
    }
  },

  beforeDestroy() {
    if (!this.bottom) {
      EventBus.$off('swipedLeft', this.clickRight)
      EventBus.$off('swipedRight', this.clickLeft)
    }
  },

  methods: {
    clickRight() {
      if (this.$store.state.isInTransition) return
      EventBus.$emit('slideHand', {
        direction: 'right',
        currentHand: this.currentHand(this.nextPage.id),
        fromMenu: false
      })
      this.$router.push(this.nextPage.id)
    },

    clickLeft() {
      if (this.$store.state.isInTransition) return
      EventBus.$emit('slideHand', {
        direction: 'left',
        currentHand: this.currentHand(this.prevPage.id),
        fromMenu: false
      })
      this.$router.push(this.prevPage.id)
    }
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  visibility: hidden;
  z-index: 25;

  pointer-events: none;

  .next,
  .prev {
    pointer-events: auto;
    align-items: flex-start;
    bottom: 20px;

    @include mq(sm) {
      bottom: 0;
      height: calc(50vh - 80px);
      padding: 0 $big-margin;
    }
  }
}

.bottom {
  position: relative;
  display: flex;
  height: auto;
  justify-content: space-between;
  margin: 0 auto;
  width: 100%;
  height: 80px;
  margin: 80px 0;

  @include mq(sm) {
    height: 115px;
  }

  .next,
  .prev {
    transform: translateY(0px);

    padding: 0 30px;

    height: 80px;
    width: 50%;

    @include mq(sm) {
      height: 0;
      padding: 0 $small-margin-mobile;
      transform: translateY(-60px);
      width: auto;
    }

    @include mq(ds) {
      transform: translateY(-55px);
    }
  }

  .next {
    background: darken($color-dark, 2%);

    @include mq(sm) {
      background: none;
      right: 55px;
    }
  }

  .prev {
    background: darken($color-dark, 5%);

    @include mq(sm) {
      background: none;
      left: 55px;
    }
  }
}

.next,
.prev {
  position: absolute;
  bottom: 0;
  display: flex;
  padding: 0 $small-margin-mobile;
  visibility: visible;
  white-space: nowrap;

  align-items: center;
  cursor: pointer;
  z-index: z-index(header);
}

.next {
  right: 10px;
}

.prev {
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Arrows.vue